import { render } from "./ProgrammeForm.vue?vue&type=template&id=4907afa4&scoped=true"
import script from "./ProgrammeForm.vue?vue&type=script&lang=js"
export * from "./ProgrammeForm.vue?vue&type=script&lang=js"

import "./ProgrammeForm.vue?vue&type=style&index=0&id=4907afa4&lang=scss&scoped=true"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4907afa4"]])

export default __exports__